/* eslint-disable array-bracket-spacing */
import apiConfig from '@constants/apiConfig';

import DevicesSavePage from './Devices/tabs/digibes/DevicesSavePage';
import DeviceSavePage from './Devices/tabs/kitplay/tabs/DeviceSavePage';
import KitplayAreaSavePage from './Devices/tabs/kitplay/tabs/KitplayAreaSavePage';
import PrinterMappingListPage from './Devices/tabs/kitplay/tabs/PrinterMapping/PrinterMappingListPage';
import PrinterMappingSavePage from './Devices/tabs/kitplay/tabs/PrinterMapping/PrinterMappingSavePage';
import PickupDisplayDeviceSavePage from './Devices/tabs/pickupDisplay/PickupDisplayDeviceSavePage';
import PickupDisplayMappingListPage from './Devices/tabs/pickupDisplay/PickupDisplayMappingListPage';
import PiServerDeviceSavePage from './Devices/tabs/piServer/PiServerDeviceSavePage';
import DeviceTab from './Devices';
import TabletRequestListPage from './TabletRequest';
import ThirdPartyListPage from './ThirdParty';
import RestaurantListPage from '.';

export const ROUTES = {
    RESTAURANT_LIST: '/restaurants',
    THIRD_PARTY_LIST: '/restaurants/third-party',
    TABLET_REQUEST_LIST: '/restaurants/tablet-request',
};

export default {
    restaurantListPage: {
        path: ROUTES.RESTAURANT_LIST,
        title: 'Website Order',
        auth: true,
        component: RestaurantListPage,
        permission: [apiConfig.restaurant.getList.baseURL],
    },
    resDeviceTabsRestaurantListPage: {
        path: '/restaurants/device/tabs',
        auth: true,
        keyActiveTab: 'activeResDeviceTab',
        title: 'Device tabs',
        component: DeviceTab,
    },
    resDevicesRestaurantSavePage: {
        path: '/restaurants/device/tabs/digibes/:id',
        title: 'Devices Save Page',
        auth: true,
        component: DevicesSavePage,
    },
    resPiServerDevicesRestaurantSavePage: {
        path: '/restaurants/device/tabs/pi-server/:id',
        title: 'Pi server devices Save Page',
        auth: true,
        component: PiServerDeviceSavePage,
    },
    resPickupDisplayDevicesRestaurantSavePage: {
        path: '/restaurants/device/tabs/pickup-display/:id',
        title: 'ReadyBoard mappings Save Page',
        auth: true,
        component: PickupDisplayDeviceSavePage,
    },
    resPickupDisplayMappingDevicesRestaurantListPage: {
        path: '/restaurants/device/tabs/pickup-display/order-display-mapping',
        title: 'ReadyBoard mappings Save Page',
        auth: true,
        component: PickupDisplayMappingListPage,
    },
    resPrinterMappingDevicesRestaurantListPage: {
        path: '/restaurants/device/tabs/kitplay/printer-mapping',
        title: 'ReadyBoard mappings Save Page',
        auth: true,
        component: PrinterMappingListPage,
    },
    resPrinterMappingDevicesRestaurantSavePage: {
        path: '/restaurants/device/tabs/kitplay/printer-mapping/:id',
        title: 'ReadyBoard mappings Save Page',
        auth: true,
        component: PrinterMappingSavePage,
    },
    resKitplayAreaDevicesRestaurantSavePage: {
        path: '/restaurants/device/tabs/kitplay/area/:id',
        title: 'Kitplay area devices Save Page',
        auth: true,
        component: KitplayAreaSavePage,
    },
    resKitplayGroupDeviceDevicesRestaurantSavePage: {
        path: '/restaurants/device/tabs/kitplay/group-device/:id',
        title: 'Kitplay group device devices Save Page',
        auth: true,
        component: DeviceSavePage,
    },
    thirdPartyListPage: {
        path: ROUTES.THIRD_PARTY_LIST,
        auth: true,
        title: 'Third party',
        component: ThirdPartyListPage,
    },
    tabletRequestRestaurantListPage: {
        path: ROUTES.TABLET_REQUEST_LIST,
        auth: true,
        title: 'Tablet Request',
        component: TabletRequestListPage,
    },
};
